/**
 *
 * Asynchronously loads the component for AssetDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InstrumentRestrictionsPage = lazyLoad(
  () => import('./index'),
  module => module.InstrumentRestrictionsPage,
);
